export default __webpack_public_path__ + "media/choose-missions3x.caf709d3.png";